__turbopack_context__.v({
  "className": "inter_tight_6a76f2d7-module__n2BIjG__className",
});
